import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorised',
  templateUrl: './unauthorised.component.html',
  styleUrls: ['./unauthorised.component.css']
})
export class UnauthorisedComponent implements OnInit {

  constructor() { }

  ngOnInit() {

    // var img = new Image()
    // img.src = '../../assets/appimages/SRI.png'
    // this.imgURL = environment.baseUrl + JSON.parse(localStorage.getItem("EmployeeData"))["PhotoFilePath"];

    const imgPath = "../../../assets/appimages/unauthorised.jpg";
  }

}
